module.exports = __webpack_public_path__ + "img/LOGO_Loading.1615ebf6.gif";